'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Modal;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function PortalImpl(_ref) {
  let {
    onClose,
    children,
    title
  } = _ref;
  const modalRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (modalRef.current !== null) {
      modalRef.current.focus();
    }
  }, []);
  (0, _react.useEffect)(() => {
    const handler = event => {
      if (event.keyCode === 27) {
        onClose();
      }
    };
    window.addEventListener('keydown', handler);
    return () => {
      window.removeEventListener('keydown', handler);
    };
  }, [onClose]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Modal__overlay",
    role: "dialog"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "Modal__modal",
    tabIndex: -1,
    ref: modalRef
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "Modal__title"
  }, title), /*#__PURE__*/_react.default.createElement("button", {
    className: "Modal__closeButton",
    "aria-label": "Close modal",
    type: "Close",
    onClick: onClose
  }, "X"), /*#__PURE__*/_react.default.createElement("div", {
    className: "Modal__content"
  }, children)));
}
function Modal(_ref2) {
  let {
    onClose,
    children,
    title
  } = _ref2;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(PortalImpl, {
    onClose: onClose,
    title: title
  }, children), document.body);
}
